import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { ProductSet } from 'entities/product_set'
import { ReactNode, useMemo } from 'react'
import { Form } from 'utils/hooks'
import { SampleViewModel } from 'view_models/sample_view_model'

export const productSetColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'ID', th: true, width: 50, form: form, orderAttr: 'product_set_id', searchType: { name: 'id', type: 'multiple_text' } },
            {
                name: '表示名',
                th: true,
                width: 250,
                form: form,
                orderAttr: 'product_set_display_name',
                searchType: { name: 'display_name', type: 'multiple_text' },
            },
            {
                name: 'CRチーム管理名称',
                th: true,
                width: 250,
                form: form,
                orderAttr: 'product_set_name',
                searchType: { name: 'name', type: 'multiple_text' },
            },
            {
                name: '価格(税抜)',
                th: true,
                width: 100,
                align: 'right',
                form: form,
                orderAttr: 'product_set_price',
                searchType: { name: 'price', type: 'number' },
            },
            {
                name: '対象',
                th: true,
                width: 100,
                align: 'center',
                form: form,
                orderAttr: 'product_set_gender',
                searchType: { name: 'gender', type: 'number' },
            },
            {
                name: '海外キット',
                th: true,
                width: 100,
                align: 'center',
                form: form,
                orderAttr: 'product_set_is_foreign_country',
                searchType: { name: 'is_foreign_country', type: 'boolean' },
            },
            {
                name: 'メモ',
                th: true,
                width: 200,
                form: form,
                orderAttr: 'product_set_note',
                searchType: { name: 'note', type: 'text' },
            },
            { name: '製品', th: true, minWidth: 300 },
        ],
    }
}

export type ProductSetTableDataProps = {
    productSet?: ProductSet
    displaySetting: DisplaySetting
}

export const ProductSetTableData = ({ productSet, displaySetting }: ProductSetTableDataProps): JSX.Element => {
    if (!productSet) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        return (
            <>
                <TableCell>{productSet.id}</TableCell>
                <TableCell>{productSet.displayName}</TableCell>
                <TableCell>{productSet.name}</TableCell>
                <TableCell align="right" unit="円">
                    {productSet.price?.toLocaleString()}
                </TableCell>
                <TableCell align="center">{productSet.gender}</TableCell>
                <TableCell>{productSet.isForeignCountry ? '対応' : '未対応'}</TableCell>
                <TableCell>{productSet.note}</TableCell>
                <TableCell>{new SampleViewModel({ productItems: productSet.productItems }).productItemView()}</TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
